/** @format */

import style from "./index.module.scss";
import { useState, useEffect } from "react";
import {createCookieThatLastsForADay, getCookie} from "../../untils/helpers";
import facebook from "../../assets/images/facebook.png";
import google from "../../assets/images/google.png";
import apple from "../../assets/images/apple.png";
import ButtonCircle from "../common/button/ButtonCircle";
import ButtonMethod from "../common/button/ButtonMethod";
import ModalInput from "../common/modal/ModalInput";
import ModalPopup from "../common/modal/modalPopup/ModalPopup";
import mochiCheer from "../../assets/images/mochi_cheer.png";
import AccountOperations from "../services/AccountOperations";
import {
    auth,
    providerApple,
    providerGoogle,
    OAuthProvider,
} from "../../firebase-config";
import { signInWithPopup } from "firebase/auth";

const Login = ({ setPageLoginSignup, setIsLogin }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [erroEmail, setErroEmail] = useState("");
    const [erroPassword, setErroPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [activeButton, setActiveButton] = useState(false);
    const [showPopupHelp, setShowPopupHelp] = useState(false);

    const middlewareEmail = (value) => {
        const regex =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (value.length === 0) {
            setErroEmail("* Email không được bỏ trống");
        } else if (value.match(regex)) {
            setErroEmail("");
        } else {
            setErroEmail("* Email sai định dạng, bạn kiểm tra lại nhé");
        }
    };

    useEffect(() => {
        if (
            email.length &&
            password.length &&
            !erroEmail.length &&
            !erroPassword.length
        ) {
            setActiveButton(true);
        } else {
            setActiveButton(false);
        }
    }, [email, password, erroEmail, erroPassword]);

    const middlewarePassword = (value) => {
        if (value.length === 0) {
            setErroPassword("* Mật khẩu không được bỏ trống");
        } else if (value.length < 6) {
            setErroPassword("* Mật khẩu cần có ít nhất 06 ký tự");
        } else {
            setErroPassword("");
        }
    };

    const handleSubmitLogin = async () => {
        if (!activeButton) return;
        try {
            let result = await AccountOperations.handleLoginEmail({
                email: email,
                password: password,
            });
            if (result.code === 1) {
                handleSaveInfoUser(result.user?.user_token, result.user?.email);
                setPageLoginSignup([]);
                // setIsOpenPopupLoginSignup({ type: null, isOpen: false });
                setIsLogin(true);
            } else if (result.code === 0) {
                if (result.msg === "Mật khẩu của bạn sai") {
                    setErroPassword(result.msg);
                } else if (result.msg === "Email của bạn chưa được đăng ký") {
                    setErroEmail(result.msg);
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleLoginGoogle = async () => {
        try {
            let result = await signInWithPopup(auth, providerGoogle);

            const credential = OAuthProvider.credentialFromResult(result);
            const googleId = credential.idToken;
            // The signed-in user info.
            const user = result.user;
            const data = new FormData();
            data.append("id_token", googleId);

            let check = await AccountOperations.LoginByThirdParty(data);

            if (check.data.code === 1) {
                handleSaveInfoUser(
                    check.data.user?.user_token,
                    check.data.user?.email
                );

                // setIsOpenPopupLoginSignup({ type: null, isOpen: false });
                setPageLoginSignup([]);

                setIsLogin(true);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleLoginApple = async () => {
        try {
            let result = await signInWithPopup(auth, providerApple);

            const credential = OAuthProvider.credentialFromResult(result);
            const appleId = credential.idToken;
            // The signed-in user info.
            const user = result.user;
            const data = new FormData();
            data.append("id_token", appleId);
            let check = await AccountOperations.LoginByThirdParty(data);
            // getAndSaveToken(data);
            if (check.data.code === 1) {
                handleSaveInfoUser(
                    check.data.user?.user_token,
                    check.data.user?.email
                );

                // setIsOpenPopupLoginSignup({ type: null, isOpen: false });
                setPageLoginSignup([]);

                setIsLogin(true);
            }
        } catch (err) {
            console.log(err);
        }
    };
    return (
        <>
            <div className={style.loginScreen}>
                <div
                    className={style.loginScreen_title}
                    style={{ marginBottom: "5%" }}>
                    <h1>Đăng nhập để học ngay nhé</h1>
                </div>

                <div className={style.loginScreen_options}>
                    <div style={{ margin: "9% auto" }}>
                        <ButtonMethod
                            isGoogle={true}
                            height={56}
                            onClick={handleLoginGoogle}
                            fontSize={"16px"}
                            Icon={() => (
                                <img
                                    className={
                                        "mx-2 " + style.loginScreen_options_icon
                                    }
                                    width={30}
                                    src={google}
                                    alt="google"
                                />
                            )}
                            buttonText={"Đăng nhập với G+"}
                        />
                    </div>
                    <div style={{ margin: "9% auto" }}>
                        <ButtonMethod
                            height={56}
                            onClick={handleLoginApple}
                            fontSize={"16px"}
                            Icon={() => (
                                <img
                                    style={{ left: 0 }}
                                    className={
                                        "mx-2 " + style.loginScreen_options_icon
                                    }
                                    width={37}
                                    src={apple}
                                    alt="facebook"
                                />
                            )}
                            buttonText={"Đăng nhập với Apple"}
                        />
                    </div>

                    <p className={style.loginScreen_or}>HOẶC</p>

                    <div className={style.formInput}>
                        <div
                            className={
                                style.formInput_container +
                                " " +
                                (erroEmail.length !== 0
                                    ? style.formInput_container_erro
                                    : "")
                            }>
                            <ModalInput
                                controller={[email, setEmail]}
                                placeholder={"Nhập email tài khoản học"}
                                middleware={middlewareEmail}
                            />
                        </div>
                        <p className={style.erroMessage}>{erroEmail || ""}</p>
                        <div
                            className={
                                style.formInput_container +
                                " " +
                                (erroPassword.length !== 0
                                    ? style.formInput_container_erro
                                    : "")
                            }>
                            <ModalInput
                                controller={[password, setPassword]}
                                placeholder={"Nhập mật khẩu tài khoản học"}
                                middleware={middlewarePassword}
                                type={showPassword ? "text" : "password"}
                            />
                            <p
                                onClick={() => setShowPassword((prev) => !prev)}
                                className={
                                    style.formInput_container_controllPassType
                                }>
                                {password.length !== 0 &&
                                    (showPassword ? "Ẩn" : "Hiển thị")}
                            </p>
                        </div>
                        <p className={style.erroMessage}>
                            {erroPassword || ""}
                        </p>

                        <div className={style.formInput_submitLine}>
                            <ButtonCircle
                                fontSize="20px"
                                buttonText="Đăng nhập"
                                onClick={handleSubmitLogin}
                                disable={!activeButton}
                            />
                        </div>
                        <div className={style.formInput_forget}>
                            <p onClick={() => setShowPopupHelp(true)}>
                                Quên mật khẩu?
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {showPopupHelp && (
                <ModalPopup
                    handleClickClose={() => {
                        setShowPopupHelp(false);
                    }}
                    classCssMoreImage={style.classCssMoreImage_forgetPassword}
                    imageSrc={mochiCheer}
                    title={
                        "Bạn hãy inbox cho Mochi để được hỗ trợ đổi mật khẩu nhé"
                    }>
                    <ButtonCircle
                        fontSize="18px"
                        height={40}
                        buttonText="Inbox cho Mochi"
                        onClick={() => {
                            setShowPopupHelp(false);
                            window.open("https://m.me/mochidemy");
                        }}
                        // disable={!activeButton}
                    />
                </ModalPopup>
            )}
        </>
    );
};
export default Login;

const handleSaveInfoUser = (user_token, email) => {
    createCookieThatLastsForADay("user_token", user_token);
    createCookieThatLastsForADay("email", email);
};
